module.exports = __webpack_public_path__ + "static/Safeguarding Statements - Website V2-b6160d4fd443f8e4d593e159607d6755.pdf";